<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

  <ng-container>

    <!-- *ngIf possui renajud? -->
    <ng-container *ngIf="possuiInformacaoRenajud">
      <h2 class="subtitle subtitle-danger ">Restrição Judicial</h2>
      <table class="table table-striped table-responsive-sm table-sm w-100 text-center">
        <thead class="fw-500 text-danger text-center">
          <th>Tribunal</th>
          <th>Restrição</th>
          <th>Processo</th>
          <th>Judiciário</th>
          <th>Data/Hora</th>
        </thead>
        <tbody>
          <tr *ngFor="let r of consulta?.listaRestricaoJudicial">
            <td>{{r?.tribunal || "NADA CONSTA"}}</td>
            <td>{{r?.tipoRestricao || "NADA CONSTA"}}</td>
            <td>{{r?.processo || "NADA CONSTA"}}</td>
            <td>{{r?.judiciario || "NADA CONSTA"}}</td>
            <td>{{r?.dataHora || "Não informado"}}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</app-card-consulta>
